// import React, { createContext, useContext, useState, useEffect } from 'react';
// import { connectSocket, getSocket } from '../services/socket.service';
// import { getConversations, getMessages } from '../services/message.service';
// import Cookies from 'js-cookie';


// interface Message {
//   id: string;
//   conversationId: string;
//   senderId: string;
//   receiverId: string;
//   text: string;
//   media?: string;
//   isRead: boolean;
//   createdAt: string;
// }

// interface Conversation {
//   id: string;
//   vehicleId: string;
//   buyerId: string;
//   sellerId: string;
//   lastMessageAt: string;
//   Vehicle?: { id: string; Title: string; Price: number; Images: string[] };
//   Buyer?: { id: string; FirstName: string; LastName: string; ProfilePhoto: string };
//   Seller?: { id: string; FirstName: string; LastName: string; ProfilePhoto: string };
//   Messages?: Message[];
// }

// interface MessagingContextType {
//   conversations: Conversation[];
//   messages: Record<string, Message[]>;
//   sendMessage: (data: { vehicleId: string; receiverId: string; text: string; media?: string }) => Promise<any>;
//   loadConversations: () => Promise<void>;
//   loadMessages: (conversationId: string) => Promise<void>;
//   markAsRead: (conversationId: string) => void;
//   unreadCounts: Record<string, number>;
// }

// const MessagingContext = createContext<MessagingContextType | undefined>(undefined);

// export const useMessaging = () => {
//   const ctx = useContext(MessagingContext);
//   if (!ctx) throw new Error('useMessaging must be used within MessagingProvider');
//   return ctx;
// };

// export const MessagingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
//   const [conversations, setConversations] = useState<Conversation[]>([]);
//   const [messages, setMessages] = useState<Record<string, Message[]>>({});
//   const [unreadCounts, setUnreadCounts] = useState<Record<string, number>>({});

//   const userId = JSON.parse(localStorage.getItem('customerUser') || '{}').id;

// useEffect(() => {
//   const token =
//     localStorage.getItem('token') ||
//     Cookies.get('token');

//   if (!token) {
//     console.warn('⚠️ No authentication token found for socket');
//     return;
//   }

//   console.log('🔌 Connecting seller socket...');

//   const socket = connectSocket(token);

//   const handleConnect = () => {
//     console.log('✅ Seller socket connected:', socket.id);
//   };

//   const handleConnectError = (error: Error) => {
//     console.error('❌ Seller socket connection error:', error.message);
//   };

//   socket.on('connect', handleConnect);
//   socket.on('connect_error', handleConnectError);
//   socket.on('newMessage', handleNewMessage);
//   socket.on('messagesRead', handleMessagesRead);

//   // If socket was already connected
//   if (socket.connected) {
//     console.log('✅ Seller socket already connected:', socket.id);
//   }

//   return () => {
//     socket.off('connect', handleConnect);
//     socket.off('connect_error', handleConnectError);
//     socket.off('newMessage', handleNewMessage);
//     socket.off('messagesRead', handleMessagesRead);
//   };
// }, []);

//   const handleNewMessage = (message: Message) => {
//     setMessages(prev => ({
//       ...prev,
//       [message.conversationId]: [...(prev[message.conversationId] || []), message],
//     }));
//     if (message.receiverId === userId && !message.isRead) {
//       setUnreadCounts(prev => ({
//         ...prev,
//         [message.conversationId]: (prev[message.conversationId] || 0) + 1,
//       }));
//     }
//   };

//   const handleMessagesRead = ({ conversationId }: { conversationId: string }) => {
//     setMessages(prev => ({
//       ...prev,
//       [conversationId]: (prev[conversationId] || []).map(msg => ({ ...msg, isRead: true })),
//     }));
//     setUnreadCounts(prev => ({ ...prev, [conversationId]: 0 }));
//   };

//   const loadConversations = async () => {
//     try {
//       const res = await getConversations();
//       if (res.success) {
//         setConversations(res.data);
//         const counts: Record<string, number> = {};
//         res.data.forEach((conv: any) => {
//           const unread = conv.Messages?.filter((m: Message) => !m.isRead && m.receiverId === userId).length || 0;
//           if (unread > 0) counts[conv.id] = unread;
//         });
//         setUnreadCounts(counts);
//       }
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   const loadMessages = async (conversationId: string) => {
//     try {
//       const res = await getMessages(conversationId);
//       if (res.success) {
//         setMessages(prev => ({ ...prev, [conversationId]: res.data }));
//         markAsRead(conversationId);
//       }
//     } catch (err) {
//       console.error(err);
//     }
//   };

// const sendMessage = (data: {
//   vehicleId: string;
//   receiverId: string;
//   text: string;
//   media?: string
// }) => {
//   return new Promise((resolve, reject) => {
//     const socket = getSocket();

//     socket.emit('sendMessage', data, (response: any) => {
//       if (response?.error) reject(response.error);
//       else resolve(response);
//     });
//   });
// };

//   const markAsRead = (conversationId: string) => {
//     const socket = getSocket();
//     socket.emit('markAsRead', { conversationId });
//     setMessages(prev => ({
//       ...prev,
//       [conversationId]: (prev[conversationId] || []).map(msg => ({ ...msg, isRead: true })),
//     }));
//     setUnreadCounts(prev => ({ ...prev, [conversationId]: 0 }));
//   };

//   return (
//     <MessagingContext.Provider
//       value={{
//         conversations,
//         messages,
//         sendMessage,
//         loadConversations,
//         loadMessages,
//         markAsRead,
//         unreadCounts,
//       }}
//     >
//       {children}
//     </MessagingContext.Provider>
//   );
// };

import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from 'react';

import {
  connectSocket,
  getSocket,
} from '../services/socket.service';

import {
  getConversations,
  getMessages,
} from '../services/message.service';

import Cookies from 'js-cookie';

interface Message {
  id: string;
  conversationId: string;
  senderId: string;
  receiverId: string;
  text: string;
  media?: string | null;
  isRead: boolean;
  createdAt: string;
  Sender?: {
    id: string;
    FirstName: string;
    LastName: string;
    CompanyName?: string | null;
    ProfilePhoto?: string | null;
  };
}

interface Conversation {
  id: string;
  vehicleId: string;
  buyerId: string;
  sellerId: string;
  lastMessageAt: string;

  Vehicle?: {
    id: string;
    Title: string;
    Price: number;
    Images: string[];
  };

  Buyer?: {
    id: string;
    FirstName: string;
    LastName: string;
    CompanyName?: string | null;
    ProfilePhoto?: string | null;
  };

  Seller?: {
    id: string;
    FirstName: string;
    LastName: string;
    CompanyName?: string | null;
    ProfilePhoto?: string | null;
  };

  Messages?: Message[];
}

interface MessagingContextType {
  conversations: Conversation[];

  messages: Record<
    string,
    Message[]
  >;

  sendMessage: (
    data: {
      vehicleId: string;
      receiverId: string;
      text: string;
      media?: string;
    }
  ) => Promise<any>;

  loadConversations: () => Promise<void>;

  loadMessages: (
    conversationId: string
  ) => Promise<void>;

  markAsRead: (
    conversationId: string
  ) => void;

  unreadCounts: Record<
    string,
    number
  >;
}

const MessagingContext =
  createContext<
    MessagingContextType | undefined
  >(undefined);

export const useMessaging = () => {

  const context =
    useContext(MessagingContext);

  if (!context) {
    throw new Error(
      'useMessaging must be used within MessagingProvider'
    );
  }

  return context;
};

export const MessagingProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {

  const [
    conversations,
    setConversations,
  ] = useState<Conversation[]>([]);

  const [
    messages,
    setMessages,
  ] = useState<
    Record<string, Message[]>
  >({});

  const [
    unreadCounts,
    setUnreadCounts,
  ] = useState<
    Record<string, number>
  >({});

  // =====================================================
  // CURRENT USER FROM COOKIE
  // =====================================================

  const getCurrentUserId = useCallback(() => {

    try {

      const userCookie =
        Cookies.get('user');

      if (!userCookie) {
        return null;
      }

      const user =
        JSON.parse(userCookie);

      return user?.id || null;

    } catch (error) {

      console.error(
        '❌ Failed to read user cookie:',
        error
      );

      return null;
    }

  }, []);

  const userId = getCurrentUserId();

  // =====================================================
  // SOCKET CONNECTION
  // =====================================================

  useEffect(() => {

    const token =
      Cookies.get('token');

    if (!token) {

      console.warn(
        '⚠️ No authentication token found'
      );

      return;
    }

    console.log(
      '🔌 Connecting messaging socket...'
    );

    const socket =
      connectSocket(token);

    const handleConnect = () => {

      console.log(
        '✅ Socket connected:',
        socket.id
      );

    };

    const handleConnectError = (
      error: Error
    ) => {

      console.error(
        '❌ Socket connection error:',
        error.message
      );

    };

    const handleNewMessage = (
      message: Message
    ) => {

      console.log(
        '📩 NEW MESSAGE:',
        message
      );

      setMessages(prev => {

        const existing =
          prev[message.conversationId] || [];

        // Prevent duplicate realtime messages
        if (
          existing.some(
            m => m.id === message.id
          )
        ) {
          return prev;
        }

        return {
          ...prev,

          [message.conversationId]: [
            ...existing,
            message,
          ],
        };

      });

      if (
        message.receiverId === userId &&
        !message.isRead
      ) {

        setUnreadCounts(prev => ({
          ...prev,

          [message.conversationId]:
            (prev[message.conversationId] || 0) + 1,
        }));

      }

    };

    const handleMessagesRead = ({
      conversationId,
    }: {
      conversationId: string;
    }) => {

      setMessages(prev => ({
        ...prev,

        [conversationId]:
          (prev[conversationId] || [])
            .map(msg => ({
              ...msg,
              isRead: true,
            })),
      }));

      setUnreadCounts(prev => ({
        ...prev,
        [conversationId]: 0,
      }));

    };

    socket.on(
      'connect',
      handleConnect
    );

    socket.on(
      'connect_error',
      handleConnectError
    );

    socket.on(
      'newMessage',
      handleNewMessage
    );

    socket.on(
      'messagesRead',
      handleMessagesRead
    );

    return () => {

      socket.off(
        'connect',
        handleConnect
      );

      socket.off(
        'connect_error',
        handleConnectError
      );

      socket.off(
        'newMessage',
        handleNewMessage
      );

      socket.off(
        'messagesRead',
        handleMessagesRead
      );

    };

  }, [userId]);

  // =====================================================
  // LOAD CONVERSATIONS
  // =====================================================

  const loadConversations =
    useCallback(async () => {

      try {

        const response =
          await getConversations();

        if (!response.success) {
          return;
        }

        setConversations(
          response.data
        );

        const counts: Record<
          string,
          number
        > = {};

        response.data.forEach(
          (conversation: Conversation) => {

            const unread =
              conversation.Messages?.filter(
                message =>
                  !message.isRead &&
                  message.receiverId === userId
              ).length || 0;

            if (unread > 0) {

              counts[
                conversation.id
              ] = unread;

            }

          }
        );

        setUnreadCounts(
          counts
        );

      } catch (error) {

        console.error(
          '❌ Failed to load conversations:',
          error
        );

      }

    }, [userId]);

  // =====================================================
  // LOAD MESSAGES
  // =====================================================

  const loadMessages =
    useCallback(async (
      conversationId: string
    ) => {

      try {

        const response =
          await getMessages(
            conversationId
          );

        if (!response.success) {
          return;
        }

        setMessages(prev => ({
          ...prev,

          [conversationId]:
            response.data,
        }));

      } catch (error) {

        console.error(
          '❌ Failed to load messages:',
          error
        );

      }

    }, []);

  // =====================================================
  // SEND MESSAGE
  // =====================================================

  const sendMessage = (
    data: {
      vehicleId: string;
      receiverId: string;
      text: string;
      media?: string;
    }
  ) => {

    return new Promise(
      (resolve, reject) => {

        const socket =
          getSocket();

        if (!socket) {

          reject(
            new Error(
              'Socket not connected'
            )
          );

          return;
        }

        if (!socket.connected) {

          reject(
            new Error(
              'Socket is not connected'
            )
          );

          return;

        }

        socket.emit(
          'sendMessage',
          data,
          (response: any) => {

            if (response?.error) {

              reject(
                new Error(
                  response.error
                )
              );

              return;
            }

            // Add our own sent message immediately.
            // Receiver also gets it via socket.
            if (
              response?.message
            ) {

              const message =
                response.message;

              setMessages(prev => {

                const existing =
                  prev[message.conversationId] || [];

                if (
                  existing.some(
                    m =>
                      m.id === message.id
                  )
                ) {
                  return prev;
                }

                return {
                  ...prev,

                  [message.conversationId]: [
                    ...existing,
                    message,
                  ],
                };

              });

            }

            resolve(response);

          }
        );

      }
    );

  };

  // =====================================================
  // MARK AS READ
  // =====================================================

  const markAsRead = (
    conversationId: string
  ) => {

    const socket =
      getSocket();

    if (
      socket &&
      socket.connected
    ) {

      socket.emit(
        'markAsRead',
        {
          conversationId,
        }
      );

    }

    setMessages(prev => ({
      ...prev,

      [conversationId]:
        (prev[conversationId] || [])
          .map(message => ({
            ...message,
            isRead: true,
          })),
    }));

    setUnreadCounts(prev => ({
      ...prev,
      [conversationId]: 0,
    }));

  };

  // =====================================================

  return (
    <MessagingContext.Provider
      value={{
        conversations,
        messages,
        sendMessage,
        loadConversations,
        loadMessages,
        markAsRead,
        unreadCounts,
      }}
    >
      {children}
    </MessagingContext.Provider>
  );

};